import { all, takeEvery, put, fork } from "redux-saga/effects";

//import axios from "axios";
import axios from "./initialize";

import { Modal } from "antd";
import {
  ExclamationCircleOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import {
  licensePurchaseProperties,
  showAccountAppLicenseMessage,
  showAppMessage,   
  setAddEdit,
  licensePricingList,
  licensePricingValueList,
  accountAppLicensesData,
  savedaccountAppLicensesData
} from "redux/actions/accountAppLicense";
import { API_BASE_DEVELOPER_APP, API_BASE_URL, APP_PREFIX_PATH, AUTH_PREFIX_PATH, MANAGE_PREPIX_PATH, USERS_PREPIX_PATH,API,VERSION } from "configs/AppConfig";
import { AUTH_TOKEN } from "../constants/Auth";
import { t } from "i18next";
import { PATH_VARIABLE } from "constants/ApiConstant";
import { appInstaneData } from "redux/actions/appInstance";
import { ADD_ACCOUNT_APP_LICENSE, ADD_ACCOUNT_APP_LICENSE_PURCHASE, DELETE_ACCOUNT_APP_LICENSE, DELETE_ACCOUNT_APP_LICENSE_PURCHASE, GET_ACCOUNT_APP_LICENSES, GET_ACCOUNT_APP_LICENSE_DATA, GET_ACCOUNT_APP_LICENSE_PURCHASES, SAVE_ACCOUNT_APP_LICENSE_DATA, UPDATE_ACCOUNT_APP_LICENSE, UPDATE_ACCOUNT_APP_LICENSE_PURCHASE } from "redux/constants/accountAppLicense";
import { accountAppLicense, accountAppLicensePurchases, accountAppLicenses } from "redux/actions/accountAppLicense";
import accountAppLicensePurchase from "views/app-views/market-place/app-instance-settings/account-app-licenses/account-app-license-purchase";
import addAccountAppLicensesPurchase from "views/app-views/market-place/app-instance-settings/account-app-licenses/add-account-app-licenses-purchase";

export function* saveAccountAppLicense() {
  yield takeEvery(ADD_ACCOUNT_APP_LICENSE, function* ({ payload }) {
    try {
      const accountId = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicenses`,
        payload,
        config
      );
      if (res.status === 200) {
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicenses?appInstanceId=${
            payload?.appInstanceId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: t("impaqx.adminApp.accountAppLicenseCreateSuccessMessage"),
            icon: <CheckCircleFilled />,
            okText: t("impaqx.adminApp.close"),
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
        }
        yield put(accountAppLicenses(response.data));
        yield put(setAddEdit(false));
      }
    } catch (err) {
      console.log(err);
      yield put(showAccountAppLicenseMessage(err?.response));
    }
  });
}

export function* getAccountAppLicense() {
  yield takeEvery(GET_ACCOUNT_APP_LICENSE_DATA, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const response = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicensesData?appInstanceId=${
          payload?.appInstanceId
        }&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );
      if (response.status === 200) {
         yield put(accountAppLicensesData(response.data));
         yield put(setAddEdit(false));
      }
    } catch (err) {
      console.log(err);
      yield put(showAccountAppLicenseMessage(err?.response));
    }
  });
}

export function* saveAccountAppLicenseData() {
  yield takeEvery(SAVE_ACCOUNT_APP_LICENSE_DATA, function* ({ payload }) {
    try {
      const accountId = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicensesData`,
        payload,
        config
      );
      if (res.status === 200) {
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicensesData?appInstanceId=${
            payload?.appInstanceId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          // Modal.success({
          //   title: t("impaqx.adminApp.accountAppLicenseCreateSuccessMessage"),
          //   icon: <CheckCircleFilled />,
          //   okText: t("impaqx.adminApp.close"),
          //   //cancelText: 'Cancel',
          //   onOk() {
          //     //deleteApp(id);
          //   },
          // });
          yield put(savedaccountAppLicensesData(response.data));
        yield put(setAddEdit(false));
        }
        
      }
    } catch (err) {
      console.log(err);
      yield put(showAccountAppLicenseMessage(err?.response));
    }
  });
}

export function* getAccountAppLicenses() {
  yield takeEvery(GET_ACCOUNT_APP_LICENSES, function* ({ payload }) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicenses?appInstanceId=${
          payload?.appInstanceId
        }&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );
      if (res.status === 200) {
        yield put(accountAppLicenses(res.data));
      }
    } catch (err) {
      console.log(err);
      yield put(showAccountAppLicenseMessage(err?.response));
    }
  });
}


export function* deleteAccountAppLicense() {
  yield takeEvery(DELETE_ACCOUNT_APP_LICENSE, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.delete(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicenses/${payload.id}`,
        config
      );
      if (res.status === 200) {
        //yield put(showAccountMessage(res));
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicenses?appInstanceId=${
            payload?.appInstanceId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${payload.licenseProperty}  ${t("impaqx.adminApp.deleteAppAccountlicenseMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(accountAppLicenses(response.data));
        }
      }
    } catch (error) {
      console.log(error);
      yield put(showAccountAppLicenseMessage(error?.response));
    }
  });
}

export function* updateAccountAppLicense() {
  yield takeEvery(UPDATE_ACCOUNT_APP_LICENSE, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.put(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicenses/${payload.id}`,
        payload,
        config
      );
      if (res.status === 200) {
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicenses?appInstanceId=${
            payload?.appInstanceId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${payload.licenseProperty}  ${t("impaqx.adminApp.updateLicensePurchasePropertiesMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(accountAppLicenses(response.data));
          yield put(setAddEdit(false));
        }
      }
    } catch (error) {
      console.log(error);
      yield put(showAccountAppLicenseMessage(error?.response));
    }
  });
}

export function* saveAccountAppLicensePurchase() {
  yield takeEvery(ADD_ACCOUNT_APP_LICENSE_PURCHASE, function* ({ payload }) {
    try {
      const accountId = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicensePurchases`,
        payload,
        config
      );
      if (res.status === 200) {
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicensePurchases?appInstanceId=${
            payload?.appInstanceId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: t("impaqx.adminApp.accountApplicenseCreateSuccessMessage"),
            icon: <CheckCircleFilled />,
            okText: t("impaqx.adminApp.close"),
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
        }
        yield put(accountAppLicensePurchase(response.data));
        yield put(setAddEdit(false));
      }
    } catch (err) {
      console.log(err);
      yield put(showAccountAppLicenseMessage(err?.response));
    }
  });
}

export function* getAccountAppLicensesPurchase() {
  yield takeEvery(GET_ACCOUNT_APP_LICENSE_PURCHASES, function* ({ payload }) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicensePurchases?appInstanceId=${
          payload?.appInstanceId
        }&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );
      if (res.status === 200) {
        yield put(accountAppLicensePurchases(res.data));
      }
    } catch (err) {
      console.log(err);
      yield put(showAccountAppLicenseMessage(err?.response));
    }
  });
}


export function* deleteAccountAppLicensePurchase() {
  yield takeEvery(DELETE_ACCOUNT_APP_LICENSE_PURCHASE, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.delete(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicensePurchases/${payload.id}`,
        config
      );
      if (res.status === 200) {
        //yield put(showAccountMessage(res));
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicensePurchases?appInstanceId=${
            payload?.appinstanceId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${payload.licenseProperty}  ${t("impaqx.adminApp.deleteAccountAppLicensePurchaseMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(accountAppLicensePurchases(response.data));
        }
      }
    } catch (error) {
      console.log(error);
      yield put(showAccountAppLicenseMessage(error?.response));
    }
  });
}

export function* updateAccountAppLicensePurchase() {
  yield takeEvery(UPDATE_ACCOUNT_APP_LICENSE_PURCHASE, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.put(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicensePurchases/${payload.id}`,
        payload,
        config
      );
      if (res.status === 200) {
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/accountAppLicensePurchases?appInstanceId=${
            res?.data?.appinstanceId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${payload.licenseProperty}  ${t("impaqx.adminApp.updateAccountAppLicensePurchaseeMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(accountAppLicensePurchases(response.data));
          yield put(setAddEdit(false));
        }
      }
    } catch (error) {
      console.log(error);
      yield put(showAccountAppLicenseMessage(error?.response));
    }
  });
}



export default function* rootSaga() {
  yield all([
    fork(getAccountAppLicenses),
    fork(saveAccountAppLicense),
    fork(deleteAccountAppLicense),
    fork(updateAccountAppLicense),
    fork(getAccountAppLicensesPurchase),
    fork(saveAccountAppLicensePurchase),
    fork(deleteAccountAppLicense),
    fork(updateAccountAppLicensePurchase),
    fork(saveAccountAppLicenseData),
    fork(getAccountAppLicense)
  ]);
}
